import axios from 'axios'

import { Message } from 'element-ui'

import router from '@/router/routerConfig'
import { read } from '../storage/session'

// 1. 新axios实例，基础配置
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_PATH,
  timeout: 10000
})

// 2. 请求拦截器
instance.interceptors.request.use(
  (config) => {
    if (read('token')) {
      config.headers.token = read('token')
    }
    return config
  },
  (err) => Promise.reject(err)
)

// 3. 响应拦截器
instance.interceptors.response.use(
  (res) => {
    // 业务逻辑成功
    if (res.data.success) {
      return res.data
    } else if (!res.data.success && res.data.status === 301) {
      router.replace(`/xxx`)
    } else {
      if (res.data.message) {
        Message({
          message: res.data.message,
          type: 'error',
        })
      }
      return Promise.reject(res.data.message || '')
    }
  },
  (err) => {
    if (err.response.status !== 200 && res.data.message) {
      Message({
        message: res.data.message,
        type: 'error',
      })
    }
    return Promise.reject(err)
  }
)

export const request = (url, method, submitData) => {
  return instance({
    url,
    method,
    [method.toUpperCase() === 'GET' ? 'params' : 'data']: submitData
  })
}
